/**
 * Downloads all active & inactive company/distributor records as a CSV file.
 * Columns: Entity ID, Parent Name, Entity Name, Status
 *
 * @param {Array} children - array of child records from useParentCodeData
 * @param {Array} parents  - array of parent records for parent name lookup
 */
export const downloadParentCodeData = (children = [], parents = []) => {
  if (!children.length) {
    alert("No data to download.");
    return;
  }

  // Build parentCode → parentName lookup
  const parentMap = Object.fromEntries(
    parents.map((p) => [p.parentCode, p.parentName || p.parentCode]),
  );

  const columns = [
    { label: "Entity ID", value: (r) => r.childCode || "" },
    {
      label: "Parent Name",
      value: (r) => parentMap[r.parentCode] || r.parentCode || "",
    },
    { label: "Entity Name", value: (r) => r.childName || "" },
    { label: "Status", value: (r) => (r.isActive ? "Active" : "Inactive") },
  ];

  const header = columns.map((c) => `"${c.label}"`).join(",");
  const rows = children.map((r) =>
    columns
      .map((c) => {
        const val = c.value(r) ?? "";
        return `"${String(val).replace(/"/g, '""')}"`;
      })
      .join(","),
  );

  const csv = [header, ...rows].join("\r\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `company_distributor_${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
};
